module.exports = __webpack_public_path__ + "4e8dec564b8bc00244ed3843684b6216.png";